import React from "react";
import StaticContentPage from "./StaticContentPage";

const DEFAULT_ABOUT_US_CONTENT = `<p>TabramEyewear is a leading wholesale supplier of premium eyewear to independent opticians across Ireland and the UK.</p><p>With years of experience in the industry, we pride ourselves on delivering quality frames at competitive trade prices with exceptional customer service.</p>`;

const AboutUs = () => {
  return <StaticContentPage title="About Us" contentKey="about_us_content" fallbackContent={DEFAULT_ABOUT_US_CONTENT} />;
};

export default AboutUs;
